import { PropertyType } from '../../../models/enum';

export const Decimals = {
    modelName: 'decimals',
    propertyType: PropertyType.Number,
    label: 'Decimals',
    placeholder: 'Decimals',
    propertyName: 'decimalsProperty',
    required: false,
    iconText: '.00',
    extraData: {
        min: 0,
        decimals: 0
    },
    messages: [
        {
            key: 'min',
            value: 'Decimals must be an integer greater than or equal to 0.'
        },
        {
            key: 'required',
            value: 'Decimals is required.'
        },
        {
            key: 'number',
            value: 'Decimals must be an integer greater than or equal to 0.'
        },
        {
            key: 'float',
            value: 'Decimals must be an integer greater than or equal to 0.'
        }
    ]
};